import React from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class ComboMultiEntier extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={(this.props.comboMultipleOption(this.props.options)).length > 0 && !this.props.disabled &&
      <button type="button" onClick={this.props.onClickAddComboMultiEntier} className="text-success ei-commun_ajouter"
              style={{display: 'inline-block', marginLeft: 5}}/>}>
        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (
            <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              { !this.props.disabled && <Grid item style={{margin: 0, padding: 0}}>
                <button type="button" onClick={() => this.props.onClickRemoveComboMultiEntier(index)}
                        className="text-danger ei-commun_enlever"
                        disabled={this.props.disabled || false}/>
              </Grid>}
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Select style={this.props.style}
                  disabled={this.props.disabled || false}
                  options={this.props.comboMultipleOption(this.props.options, data.id)}
                  onChange={this.props.onChangeComboMultiEntier}
                  name={index}
                  value={data.id}/>
              </Grid>
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Input
                  type='number' style={{width: '100%'}}
                  disabled={this.props.disabled || false}
                  onChange={(e) => this.props.onChangeInputComboMultiEntier(e, index)}
                  value={data.valeur_entier}/>
              </Grid>
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboMulti/ComboMultiEntier.js